export const reportWorkspaceEn = {
  "cowork.report.workspace.deleteConfirm": "Delete {{title}}? This report will no longer be available.",
  "cowork.report.workspace.deleteError": "Could not delete the report. Please try again.",
  "cowork.report.workspace.view": "Report workspace",
  "cowork.report.workspace.list": "Report list",
  "cowork.report.workspace.open": "Open full page",
  "cowork.report.workspace.copy": "Copy preview link",
  "cowork.report.workspace.copied": "Link copied",
  "cowork.report.workspace.copyError": "Could not copy the link. Please try again.",
  "cowork.report.workspace.choose": "Choose a report",
  "cowork.report.workspace.fitWidth": "Fit width",
  "cowork.report.workspace.fitPage": "Fit page",
  "cowork.report.workspace.actualSize": "Actual size",
  "cowork.report.workspace.fullPage": "Full page",
  "cowork.report.workspace.back": "Back to review",
  "cowork.report.workspace.print": "Print / Save as PDF",
  "cowork.report.workspace.printHint": "Choose Save as PDF in the print dialog to export this report.",
  "cowork.report.workspace.printError": "Could not open the print dialog. Download the report and print it from your viewer.",
  "cowork.report.workspace.unsaved": "Unsaved comment",
  "cowork.approval.workspace.reportScoped": "Reviewers for the selected report",
  "cowork.approval.workspace.allReports": "All reports",
  "cowork.approval.workspace.search": "Search reviewers or feedback",
  "cowork.approval.workspace.noMatches": "No reviewers match your search or filter.",
  "cowork.approval.workspace.emailHint": "Separate email addresses with commas, spaces, semicolons, or new lines.",
  "cowork.approval.workspace.invalidEmails": "Check these email addresses: {{emails}}",
  "cowork.approval.workspace.assigned": "Already assigned reviewers will be skipped.",
  "cowork.approval.workspace.duplicate": "This reviewer is already assigned to this report.",
  "cowork.approval.workspace.copyLink": "Copy review link",
  "cowork.approval.workspace.feedback": "Message and feedback",
  "cowork.approval.workspace.ready": "Report ready",
  "cowork.approval.workspace.assignedStep": "Reviewers assigned",
  "cowork.approval.workspace.decision": "Final decision",
  "cowork.approval.workspace.sent": "Review request sent.",
} as const

export const reportWorkspaceEt: Record<keyof typeof reportWorkspaceEn, string> = {
  "cowork.report.workspace.deleteConfirm": "Kas kustutada „{{title}}“? See aruanne pole seejärel enam saadaval.",
  "cowork.report.workspace.deleteError": "Aruannet ei saanud kustutada. Proovi uuesti.",
  "cowork.report.workspace.view": "Aruannete tööruum",
  "cowork.report.workspace.list": "Aruannete loend",
  "cowork.report.workspace.open": "Ava täislehekülg",
  "cowork.report.workspace.copy": "Kopeeri eelvaate link",
  "cowork.report.workspace.copied": "Link kopeeritud",
  "cowork.report.workspace.copyError": "Linki ei saanud kopeerida. Proovi uuesti.",
  "cowork.report.workspace.choose": "Vali aruanne",
  "cowork.report.workspace.fitWidth": "Mahuta laiusesse",
  "cowork.report.workspace.fitPage": "Mahuta lehele",
  "cowork.report.workspace.actualSize": "Tegelik suurus",
  "cowork.report.workspace.fullPage": "Täislehekülg",
  "cowork.report.workspace.back": "Tagasi ülevaatusse",
  "cowork.report.workspace.print": "Prindi / Salvesta PDF-ina",
  "cowork.report.workspace.printHint": "Aruande eksportimiseks vali printimisdialoogis „Salvesta PDF-ina“.",
  "cowork.report.workspace.printError": "Printimisdialoogi ei saanud avada. Laadi aruanne alla ja prindi see failivaaturist.",
  "cowork.report.workspace.unsaved": "Salvestamata kommentaar",
  "cowork.approval.workspace.reportScoped": "Valitud aruande ülevaatajad",
  "cowork.approval.workspace.allReports": "Kõik aruanded",
  "cowork.approval.workspace.search": "Otsi ülevaatajaid või tagasisidet",
  "cowork.approval.workspace.noMatches": "Otsingule või filtrile vastavaid ülevaatajaid ei leitud.",
  "cowork.approval.workspace.emailHint": "Eralda e-posti aadressid komade, tühikute, semikoolonite või reavahetustega.",
  "cowork.approval.workspace.invalidEmails": "Kontrolli neid e-posti aadresse: {{emails}}",
  "cowork.approval.workspace.assigned": "Juba määratud ülevaatajaid uuesti ei lisata.",
  "cowork.approval.workspace.duplicate": "See ülevaataja on sellele aruandele juba määratud.",
  "cowork.approval.workspace.copyLink": "Kopeeri ülevaatuse link",
  "cowork.approval.workspace.feedback": "Sõnum ja tagasiside",
  "cowork.approval.workspace.ready": "Aruanne valmis",
  "cowork.approval.workspace.assignedStep": "Ülevaatajad määratud",
  "cowork.approval.workspace.decision": "Lõplik otsus",
  "cowork.approval.workspace.sent": "Ülevaatuskutse saadetud.",
}

export const reportWorkspaceRu: Record<keyof typeof reportWorkspaceEn, string> = {
  "cowork.report.workspace.deleteConfirm": "Удалить «{{title}}»? После этого отчёт станет недоступен.",
  "cowork.report.workspace.deleteError": "Не удалось удалить отчёт. Повторите попытку.",
  "cowork.report.workspace.view": "Рабочая область отчётов",
  "cowork.report.workspace.list": "Список отчётов",
  "cowork.report.workspace.open": "Открыть на отдельной странице",
  "cowork.report.workspace.copy": "Скопировать ссылку на предварительный просмотр",
  "cowork.report.workspace.copied": "Ссылка скопирована",
  "cowork.report.workspace.copyError": "Не удалось скопировать ссылку. Повторите попытку.",
  "cowork.report.workspace.choose": "Выберите отчёт",
  "cowork.report.workspace.fitWidth": "По ширине страницы",
  "cowork.report.workspace.fitPage": "Вместить страницу",
  "cowork.report.workspace.actualSize": "Фактический размер",
  "cowork.report.workspace.fullPage": "Полная страница",
  "cowork.report.workspace.back": "Вернуться к проверке",
  "cowork.report.workspace.print": "Печать / Сохранить в PDF",
  "cowork.report.workspace.printHint": "Для выгрузки отчёта выберите «Сохранить в PDF» в окне печати.",
  "cowork.report.workspace.printError": "Не удалось открыть окно печати. Скачайте отчёт и распечатайте его в программе просмотра.",
  "cowork.report.workspace.unsaved": "Несохранённый комментарий",
  "cowork.approval.workspace.reportScoped": "Рецензенты выбранного отчёта",
  "cowork.approval.workspace.allReports": "Все отчёты",
  "cowork.approval.workspace.search": "Поиск рецензентов и отзывов",
  "cowork.approval.workspace.noMatches": "По вашему запросу или фильтру рецензенты не найдены.",
  "cowork.approval.workspace.emailHint": "Разделяйте адреса электронной почты запятыми, пробелами, точками с запятой или переносами строк.",
  "cowork.approval.workspace.invalidEmails": "Проверьте эти адреса электронной почты: {{emails}}",
  "cowork.approval.workspace.assigned": "Уже назначенные рецензенты не будут добавлены повторно.",
  "cowork.approval.workspace.duplicate": "Этот рецензент уже назначен для данного отчёта.",
  "cowork.approval.workspace.copyLink": "Скопировать ссылку на проверку",
  "cowork.approval.workspace.feedback": "Сообщение и отзыв",
  "cowork.approval.workspace.ready": "Отчёт готов",
  "cowork.approval.workspace.assignedStep": "Рецензенты назначены",
  "cowork.approval.workspace.decision": "Окончательное решение",
  "cowork.approval.workspace.sent": "Запрос на проверку отправлен.",
}
